/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
export const useStyles = theme => ({
  notification: {
    background: theme?.palette?.backgroundColor,
    color: theme?.palette?.textHeading,
    width: '100%',
    p: '0.7rem',
    display: 'flex',
    justifyContent: 'center',

    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
});
